// AUTO-GENERATED by scripts/generate-version.js — do not edit, do not commit.
export const BUILD_ID = "1.0.1-1793724946617";
export const APP_VERSION = "1.0.1";
